import { z } from 'zod';

const LENGTH = 'orders:editAddress.validation.length';
const required = (max: number) =>
  z
    .string()
    .trim()
    .min(1, { error: 'orders:editAddress.validation.required' })
    .max(max, { error: LENGTH });
const optional = (max: number) => z.string().trim().max(max, { error: LENGTH });

/** Mirrors PostalAddressInput and its limits; optional strings are sent as null when blank. */
export const addressSchema = z.object({
  firstName: optional(120),
  lastName: required(120),
  company: optional(120),
  line1: required(200),
  line2: optional(200),
  city: required(120),
  region: optional(120),
  postalCode: optional(20),
  countryCode: z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^[A-Z]{2}$/, { error: 'orders:editAddress.validation.country' }),
  phone: optional(40),
});

export type AddressFormInput = z.input<typeof addressSchema>;
export type AddressFormOutput = z.output<typeof addressSchema>;

/** Form fields in display order; also the known paths for backend field errors. */
export const ADDRESS_FIELDS = [
  'firstName',
  'lastName',
  'company',
  'line1',
  'line2',
  'city',
  'region',
  'postalCode',
  'countryCode',
  'phone',
] as const satisfies ReadonlyArray<keyof AddressFormInput>;
